export const taglineGroups = {
  sky: [
    "Look up — the sky has room for everything you feel.",
    "The clouds drift to remind you that nothing stays heavy forever.",
    "Sky thinking begins when you lift your gaze from the ground.",
    "Let the sky clear your thoughts like morning air.",
    "The light above you is wider than any worry within you."
  ],

  wind: [
    "Let the wind carry your worries away.",
    "The breeze knows how to lift what you no longer need.",
    "Wind in your hair is a promise of possibility.",
    "The wind whispers courage into quiet hearts.",
    "Movement is its own kind of healing."
  ],

  rain: [
    "Let the rain wash away what no longer belongs.",
    "Rain softens the world so your heart can breathe.",
    "Even the sky cries sometimes — and still clears.",
    "Let the rain settle your thoughts into clarity.",
    "The world glows differently after a good rain."
  ],

  snow: [
    "Let the snow lift your spirit into quiet wonder.",
    "Snowfall turns the world into a soft beginning.",
    "Every snowflake carries a moment of calm.",
    "Snow hushes the noise so your heart can speak.",
    "A snowy day is a gentle reset."
  ],

  openRoad: [
    "The open road reflects back the truths you’re ready to hear.",
    "Step onto the open road — it’s waiting for you.",
    "Just go — the world opens when you move.",
    "Every mile carries a message if you listen softly enough.",
    "Your footsteps write the story the road has been waiting for."
  ],

  calmSpirit: [
    "A calm spirit sees the road more clearly.",
    "A steady mind turns the journey into a joy.",
    "Quiet your thoughts and the world begins to speak.",
    "Stillness is not the absence of movement — it’s the presence of clarity.",
    "Sometimes the quietest moments say the most."
  ],

  // ⭐ Your two extra clusters — rename them however you like
  freedom: [
    "Let the world open around you like a map of possibility.",
    "Freedom begins the moment you choose yourself.",
    "Go where your spirit feels weightless.",
    "The horizon widens with every brave breath you take.",
    "You are free to begin again — right now."
  ],

  reflectiveSky: [
  "A calm spirit sees beauty where others rush past.",
  "A steady mind turns the ordinary into something luminous.",
  "Quiet your thoughts and the world begins to speak.",
  "Look up — the sky has been waiting to speak to you.",
  "Let the quiet between moments tell you something true.",
  "Sky thinking begins when you lift your gaze from the ground.",
  "The world softens when your spirit does.",
  "Let the horizon remind you how far you can go.",
  "The sky above you is wider than any worry within you.",
  "Look up and see how the light finds you."
]

};
